import fastSort from 'fast-sort';
export default {
	data() {
		return {
			localFilters: [],
			sortByColumns: []
		};
	},
	computed: {
		filteredItems() {
			if (this.localFilters.length > 0) {

				let items = this.items
					.filter(
						x => this.localFilters.every(y => y(x))
					);

				this.$emit('filtered', items.map(x => x.id));
				return items;
			}
			this.$emit('filtered', null);
			return Array.from(this.items);
		},
		sortedItems() {
			if (this.sortByColumns.length === 0)
				return this.filteredItems;

			let defs = this.sortByColumns
				.map(x => this._getColumnByName(x))
				.filter(x => Boolean(x));

			let comparableValueGetters = defs
				.map(x => ({ [x.direction]: x.comparableValueGetter }));

			let sortedResult = Array.from(this.filteredItems);

			fastSort(sortedResult).by(comparableValueGetters);

			return sortedResult;
		},
	},
	methods: {
		_defineDefaultSortByColumns() {
			if (this.sortByColumns.length > 0) return;
			let sortableColumnDefs = Object.values(this.localColumnDefinitions).filter(x => x.sortable !== false && (x.sortDirection || x.sortOrder));
			sortableColumnDefs.sort((a,b) => {
				let aNum = isNaN(a.sortOrder) ? Number.MAX_SAFE_INTEGER : a.sortOrder;
				let bNum = isNaN(b.sortOrder) ? Number.MAX_SAFE_INTEGER : b.sortOrder;
				return aNum - bNum;
			});
			for (let columnDef of sortableColumnDefs) {
				let column = this._getColumnByName(columnDef.field);
				if (!column) continue;

				if (this.sortByColumns.indexOf(column.field) === -1)
					this.sortByColumns.push(column.field);

				if (columnDef.sortDirection === 'desc')
					this.$set(column, 'direction', 'desc');
				else
					this.$set(column, 'direction', 'asc');

				if (!column.comparableValueGetter) {
					let comparableValueGetter = this._createComparableValueGetter(column);
					this.$set(column, 'comparableValueGetter', comparableValueGetter);
				}
			}

			this._calculateSortOrders();
		},

		_addColumnToSort(column) {
			let { sortable } = this.localColumnDefinitions[column.field];
			if (sortable === false) return;
			if (this.sortByColumns.indexOf(column.field) === -1)
				this.sortByColumns.push(column.field);

			this._changeSortDirection(column);

			if (!column.comparableValueGetter) {
				let comparableValueGetter = this._createComparableValueGetter(column);
				this.$set(column, 'comparableValueGetter', comparableValueGetter);
			}
			this._calculateSortOrders();
		},

		_setColumnToSort(column) {
			let { sortable } = this.localColumnDefinitions[column.field];
			if (sortable === false) return;
			let cols = this.sortByColumns.map(x => this._getColumnByName(x)).filter(x => Boolean(x));
			for (let col of cols) {
				if (col.field === column.field) continue;
				this.$delete(col, 'sortOrder');
				this.$delete(col, 'direction');
			}
			this.$set(this, 'sortByColumns', [column.field]);
			if (!column.comparableValueGetter) {
				let comparableValueGetter = this._createComparableValueGetter(column);
				this.$set(column, 'comparableValueGetter', comparableValueGetter);
			}

			this._changeSortDirection(column);
			this._calculateSortOrders();
		},

		_createComparableValueGetter(column) {
			let columnDef = this.localColumnDefinitions[column.field];
			if (column.comparableValueGetter) {
				return column.comparableValueGetter;
			} else if (columnDef.comparableValueGetter) {
				return columnDef.comparableValueGetter;
			} else if (columnDef.valueGetter) {
				return (a) => columnDef.valueGetter(a);
			} else {
				return (a) => a[column.field];
			}
		},

		_changeSortDirection(column) {
			if (column.direction === 'desc') {
				this.$delete(column, 'sortOrder');
				this.$delete(column, 'direction');
				let index = this.sortByColumns.indexOf(column.field);
				this.sortByColumns.splice(index, 1);
			} else if (column.direction === 'asc') {
				this.$set(column, 'direction', 'desc');
			} else {
				this.$set(column, 'direction', 'asc');
			}
		},

		_getColumnByName(name) {
			for (let column of this.localColumns) {
				if (column.field === name)
					return column;
			}
			return undefined;
		},

		_getSortDirectionCharacter(column) {
			if (column.direction === 'desc') {
				return '↓';
			} else {
				return '↑';
			}
		},

		_calculateSortOrders() {
			for (let i = 0; i < this.sortByColumns.length; i++) {
				let sortDef = this.sortByColumns[i];
				for (let j = 0; j < this.localColumns.length; j++) {
					let column = this.localColumns[j];
					if (column.field === sortDef) {
						this.$set(column, 'sortOrder', i+1);
						break;
					}
				}
			}
		},

		_getSortColumnsFromColumns(columns) {
			let result = [];
			for (let column of columns) {
				if (column.sortOrder)
					result.splice(column.sortOrder - 1, 0, column.field);
				else
					result.push(column.field);
			}
			return result;
		},

		_setColumnsToSortFromSortArray(sortArray) {
			if (!sortArray || sortArray.length === 0) return;
			for (let item of sortArray) {
				if (!item.field) return;
				let column = this._getColumnByName(item.field);
				if (!column) return;
				this._addColumnToSort(column);
				if (item.direction) {
					this.$set(column, 'direction', item.direction);
				}
			}
		},
	},
	watch: {
		sort(newValue, oldValue) {
			if (oldValue === newValue) return;
			this._setColumnsToSortFromSortArray(newValue);
		},
		columns(newValue, oldValue) {
			if (oldValue === newValue) return;
			let sortByColumns = this._getSortColumnsFromColumns(newValue);
			this.$set(this, 'sortByColumns', sortByColumns);
		},
		filters(newValue, oldValue) {
			if (oldValue === newValue) return;

			this.localFilters = newValue;
		}
	},
	mounted() {
		if (this.filters)
			this.localFilters = this.filters;
		if (this.sort)
			this._setColumnsToSortFromSortArray(this.sort);

		this._defineDefaultSortByColumns();
	}
};